// import Vue from 'vue'
// import { API_URL } from '@/config'

export const mailing_delivery = {

  namespaced: true,

  state: {

  },

  getters: {

  },

  mutations: {

  },

  actions: {

  }
}
